import { render, staticRenderFns } from "./SubmitMatch.vue?vue&type=template&id=1e1bf340&"
import script from "./SubmitMatch.vue?vue&type=script&lang=js&"
export * from "./SubmitMatch.vue?vue&type=script&lang=js&"
import style0 from "./SubmitMatch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports